import {AudioHandler} from "./audio";
import {JuvolyWS} from "./juvolyWS";
import {GoogleSpeechWS} from "./googleSpeechWS";
import {WS, WSErrorHandler, WSTranscriptHandler} from "./ws";
import {logEvent} from "firebase/analytics";
import {firebaseAnalytics} from "../../firebaseConfig";

// This file maintains two WebSocket connections for transmitting audio chunks. It also includes an audio handler that
// captures audio from the client’s browser.


export class AudioChannel {
    private ws: WS | null = null

    public transcriptHandler: WSTranscriptHandler | null = null
    public errorHandler: WSErrorHandler | null = null
    private readonly language: string;
    private readonly baseAPIUrl: string;
    private readonly audioHandler = new AudioHandler();

    constructor(language: string) {
        this.language = language;
        this.baseAPIUrl = process.env.REACT_APP_BACKEND_WS_URL ?? "/api";
    }

    async connect() {
        // This method connects to the WebSocket servers for audio transcription.
        // It first attempts to connect to the Juvoly WebSocket, and if that fails,
        // it falls back to the Google Speech WebSocket.

        const wsList = [
            new JuvolyWS(this.language),
            new GoogleSpeechWS(this.baseAPIUrl)
        ]

        for (const ws of wsList) {
            try {
                console.info(`[AudioChannel] Connecting to ${ws.name}`)
                ws.transcriptHandler = this.transcriptHandler
                await ws.connect()

                ws.errorHandler = this.errorHandler
                this.ws = ws
                logEvent(firebaseAnalytics, "ws_connect", {ws_name: ws.name})
                return ws.name
            } catch (e) {
                console.error(e)
            }
        }
        return ''
    }

    private handleChunk = (buffer: ArrayBuffer) => {
        this.ws?.send(buffer)
    };

    async setAudioScreenInput(getStream: () => Promise<MediaStream>) {
        await this.audioHandler.setAudioScreenInput(getStream, this.handleChunk);
    }

    async setAudioInput(getStream: () => Promise<MediaStream>) {
        await this.audioHandler.setAudioInput(getStream, this.handleChunk);
    }

    public async stop() {
        this.audioHandler.stop();
        await this.ws?.close()
        //
        // if (this.chunkedUploadWS) {
        //     try {
        //         const sessionId = await this.chunkedUploadWS.end();
        //         console.log(`Audio session completed, server session ID: ${sessionId}`);
        //     } catch (e) {
        //         console.error(`Failed to finalize server session:`, e);
        //     } finally {
        //         this.chunkedUploadWS.close();
        //     }
        // }

        console.info(`[AudioChannel] WebSockets stopped`);
    }
}
